// const SITEURL = 'https://dev.tipmrebuilders.com';
// const SITEAUTH = 'Basic Y2tfM2VkN2JlNDFhYjQ4M2NjZTBiNTZkYTUwMWFkN2U0OGJhMjljOTQ2MDpjc18xZGMwZjI3YzBkZjBhMTBmYjFkMTM4ZDBjODRjMmY2Y2E3NmVhNjJm';

//const SITEURL = location.origin;
const SITEURL = 'https://ecmrebuilders.com';
const TIPM_AUTH = 'Basic Y2tfYjJmOTY2OGJkNDhmYmJhMDlmMDQ0YjU2NDBhMDIxNTAxNzQxOWRiODpjc18wMjRhYjE3Y2ZlYWVjZTQzOWFjMjhkMWY4OTBlNzIyMDZjZmM2NDEw';
const ECM_AUTH = 'Basic Y2tfYjJmOTY2OGJkNDhmYmJhMDlmMDQ0YjU2NDBhMDIxNTAxNzQxOWRiODpjc18wMjRhYjE3Y2ZlYWVjZTQzOWFjMjhkMWY4OTBlNzIyMDZjZmM2NDEw';
const SITEAUTH = SITEURL.includes('tipm') ? TIPM_AUTH : ECM_AUTH;
const CURRENT_STOREID = '235901';

const ECMURL = 'https://ecmrebuilders.com';
const TIPMURL = 'https://tipmrebuilders.com';
const SERVICESURL = 'https://maksservices-whhqd.kinsta.app';
const MAKROURL = 'https://server.makroerp.com/server';

const TIPM_SUPPORT_EMAIL = 'support@tipmrebuilders.com';
const ECM_SUPPORT_EMAIL = 'support@ecmrebuilders.com';
const SUPPORT_EMAIL = SITEURL.includes('tipm') ? TIPM_SUPPORT_EMAIL : ECM_SUPPORT_EMAIL;

const PARTNERURL = 'https://makspartnerprogram.com/';
const DATABASE_URL = 'https://tipmrebuilders.com/rest/provide_your_vin_tracker.php?type=';
//const TIPM_AUTH = 'Basic Y2tfYzY1MWQ2Mjg0MWQzMjliN2I0Y2EzYTVhOTVhZmYzODhjYjdlN2UwNjpjc19iZjQ0NGQ2MzAzYTBmOWQ1YzgwZjkwNDIwMTE0ZTgyM2Q1Y2Q5N2Qz';
//const ECM_AUTH = 'Basic Y2tfYjVmM2U4YjlkMmQxZDZiNTljY2IyNzAzMWU2ZDMyNjFmZjYwMmEwNjpjc19mZjJlMTNhODNmN2JkZDMzMmQ0ZjkzM2Y3MmYzZTNlZTQ2NTBkYmJk';
//const NEW_ECM_AUTH = 'Basic Y2tfYjJmOTY2OGJkNDhmYmJhMDlmMDQ0YjU2NDBhMDIxNTAxNzQxOWRiODpjc18wMjRhYjE3Y2ZlYWVjZTQzOWFjMjhkMWY4OTBlNzIyMDZjZmM2NDEw';
//const NEW_TIPM_AUTH = 'Basic Y2tfMjFmNmZjYThhMzJhNGI0NTgxZmI3NjI4YjBkZmM4NTgwMGVkODAwZjpjc18zYWI4MzU5MDM2YjFlM2YyZjdjOTk2YThiNWM3NmE3NzY3MWIwYzk4';
const SHIPSTATION_AUTH = 'Basic N2NiYmIxZGNiMmMzNGZiMGJmNWE2MDJlM2E5MTljOGE6YWNmMmEyMTllODE3NDM4MGEwZGRhM2U0NzE0NGFmMzA=';
const AUTH_KEY = 'chocoRoast@230b3e54cc0f6e8317151dcbc6aaad0b0c';

const STAMPS_COM_BASE_URL = 'https://database.tipmrebuilders.com/shipstation/stamps_com.rest.php?op=get_tracking_details&carrier_code=stamps_com&tracking_number=';
//const SHIPSTATION_BASE_URL = 'https://database.tipmrebuilders.com/shipstation/shipment.rest.php?op=';
const SHIPSTATION_BASE_URL = 'https://ssapi.shipstation.com/';
const FEDEX_BASE_URL = 'https://database.tipmrebuilders.com/shipstation/fedex.rest.php';
const FEDEX_TRACKING_BASE_URL = 'https://www.fedex.com/fedextrack/?trknbr=';
const USPS_TRACKING_BASE_URL = 'https://tools.usps.com/go/TrackConfirmAction.action?tLabels=';
const DHL_TRACKING_BASE_URL = 'https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=';
const STAMPS_COM_LOGO = 'https://tipmrebuilders.com/wp-content/uploads/2023/10/usps_logo-icon-white.png';
const FEDEX_LOGO = 'https://tipmrebuilders.com/wp-content/uploads/2023/10/fedex_logo_white.png';
const DHL_LOGO = 'https://tipmrebuilders.com/wp-content/uploads/2023/10/dhl_logo.png';


const STAMPS_COM_CARRIER_CODE = 'stamps_com';
const STAMPS_COM_SERVICE_CODE = 'usps_ground_advantage';
const STAMPS_COM_COLOR = '#00447B';
const FEDEX_CARRIER_CODE = 'fedex';
const FEDEX_COLOR = '#4D148C';
const DHL_CARRIER_CODE = 'dhl_express_worldwide';
const DHL_COLOR = "#FFCC00";

const SHIPSTATION_STOREID_TIPM = '69270';
const SHIPSTATION_STOREID_ECM = '235901';

const COMPANY_PHONE_NUMBER = '+1818-798-5558';
const COMPANY_ADDRESS = '9531 Cozycroft Avenue, Chatsworth, CA 91311';

const PARTNER_DISCOUNT_PERCENTAGE = '15';

const RVC_PRICE = '75.00';
const COLORED_LID_PRICE = '34.99';
const RVC_TITLE = 'Program to my vehicle';
const LID_TITLE = 'Colored Lid';
const TIMEOUT_DURATION = '3600000';
const AUTH_INTERVAL = '5,184,000,000';

const NOTE_TEXT = 'Customer has provided their VIN';
//const NOTE_TEXT = 'This is a TEST please ignore';


const LOGIN_TYPE = {
    PARTNER: 'partner',
    CUSTOMER: 'customer',
    ADMIN: 'admin'
}
const ORDER_STATUS = {
    CREATED: 'Order Received',
    PROCESSING: 'Processing',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
    FAILED: 'Failed',
    AWAITING_PAYMENT: 'Pending Payment',
    VIN_REQUIRED: 'VIN Required',
    ON_HOLD: 'On Hold',
    READY_FOR_PICK_UP: 'Ready for Pickup',
    PICKED_UP: 'Picked Up',
    DELIVERED: 'Delivered',
    REFUNDED: 'Refunded',
    SHIPPED: 'Shipped',
    AWAITING_SHIPMENT: 'Awaiting Shipment'
}

const CSR_AGENTS_LOOKUP_TIPM = [
    {
        id: '12649',
        email: 'henry@tipmrebuilders.com',
        image: 'default.png',
        name: "Henry Yee",
        first_name: "Henry",
        last_name: "Yee"
    },
    {
        id: '12778',
        email: 'amal@tipmrebuilders.com',
        image: 'amal.jpeg',
        name: "Amal Conception",
        first_name: "Amal",
        last_name: "Conception"
    },
    {
        id: '12987',
        email: 'chase@tipmrebuilders.com',
        image: 'chase.jpeg',
        name: "Chase Conner",
        first_name: "Chase",
        last_name: "Conner"
    },
    {
        id: '12981',
        email: 'franz@maksdts.com',
        image: 'franz.jpeg',
        name: "Franz Benarao",
        first_name: "Franz",
        last_name: "Benarao"
    },
    {
        id: '12985',
        email: 'jevic@maksdts.com',
        image: 'jevic.jpeg',
        name: "Jevic Venenoso",
        first_name: "Jevic",
        last_name: "Venenoso"
    },
    {
        id: '12991',
        email: 'charlesdeo@maksdts.com',
        image: 'charlesdeo.jpeg',
        name: "Charlesdeo Bansi",
        first_name: "Charlesdeo",
        last_name: "Bansi"
    },
    {
        id: '12992',
        email: 'markjohn@maksdts.com',
        image: 'default.png',
        name: "Mark John Wittlin",
        first_name: "Mark John",
        last_name: "Wittlin"
    },
]

const STATES = {
    "AL": "Alabama",
    "AK": "Alaska",
    "AZ": "Arizona",
    "AR": "Arkansas",
    "CA": "California",
    "CO": "Colorado",
    "CT": "Connecticut",
    "DE": "Delaware",
    "FL": "Florida",
    "GA": "Georgia",
    "HI": "Hawaii",
    "ID": "Idaho",
    "IL": "Illinois",
    "IN": "Indiana",
    "IA": "Iowa",
    "KS": "Kansas",
    "KY": "Kentucky",
    "LA": "Louisiana",
    "ME": "Maine",
    "MD": "Maryland",
    "MA": "Massachusetts",
    "MI": "Michigan",
    "MN": "Minnesota",
    "MS": "Mississippi",
    "MO": "Missouri",
    "MT": "Montana",
    "NE": "Nebraska",
    "NV": "Nevada",
    "NH": "New Hampshire",
    "NJ": "New Jersey",
    "NM": "New Mexico",
    "NY": "New York",
    "NC": "North Carolina",
    "ND": "North Dakota",
    "OH": "Ohio",
    "OK": "Oklahoma",
    "OR": "Oregon",
    "PA": "Pennsylvania",
    "RI": "Rhode Island",
    "SC": "South Carolina",
    "SD": "South Dakota",
    "TN": "Tennessee",
    "TX": "Texas",
    "UT": "Utah",
    "VT": "Vermont",
    "VA": "Virginia",
    "WA": "Washington",
    "WV": "West Virginia",
    "WI": "Wisconsin",
    "WY": "Wyoming"
};
const VEHICLE_CONFIG_META = 'vehicle_configuration_content';
const VIN_META = 'vinInput2';
const COLORED_LID_META = 'final_lid_color';
const PROVIDE_VIN_LATER = 'PROVIDE VIN LATER';
const TIMELINE_OBJECT = [
    {
        'step_id': 1,
        'id': 1,
        'defaultClass': 'success',
        'icon': 'fa-duotone fa-solid fa-clipboard-list-check text-white',
        'status': ORDER_STATUS.CREATED,
        'statusTitle': ORDER_STATUS.CREATED,
        'statusSubtitle': 'Order has been created',
        'date': null,
        'isActive': true,
        'isHidden': false,
    },
    {
        'step_id': 2,
        'id': 2,
        'defaultClass': 'danger',
        'icon': 'fa-sharp-duotone fa-solid fa-circle-exclamation text-white',
        'status': ORDER_STATUS.FAILED,
        'statusTitle': 'Order '+ORDER_STATUS.FAILED,
        'statusSubtitle': "Your Order Couldn't Be Processed",
        'date': null,
        'isActive': true,
        'isHidden': true,
    },
    {
        'step_id': 2,
        'id': 3,
        'defaultClass': 'secondary',
        'icon': 'fa-duotone fa-solid fa-ban text-white',
        'status': ORDER_STATUS.CANCELLED,
        'statusTitle': 'Order '+ORDER_STATUS.CANCELLED,
        'statusSubtitle': "Your Order Has Been Cancelled",
        'date': null,
        'isActive': true,
        'isHidden': true,
    },
    {
        'step_id': 2,
        'id': 4,
        'defaultClass': 'warning',
        'icon': 'fa-sharp-duotone fa-solid fa-barcode text-white',
        'status': ORDER_STATUS.VIN_REQUIRED,
        'statusTitle': ORDER_STATUS.VIN_REQUIRED,
        'statusSubtitle': "Please provide your VIN",
        'date': null,
        'isActive': true,
        'isHidden': true,
    },
    {
        'step_id': 2,
        'id': 5,
        'defaultClass': 'warning',
        'icon': 'fa-duotone fa-solid fa-hand text-white',
        'status': ORDER_STATUS.ON_HOLD,
        'statusTitle': ORDER_STATUS.ON_HOLD,
        'statusSubtitle': "Your Order is temporarily paused",
        'date': null,
        'isActive': true,
        'isHidden': true,
    },
    {
        'step_id': 3,
        'id': 6,
        'defaultClass': '',
        'icon': 'fa-duotone fa-solid fa-hourglass-clock text-white',
        'status': ORDER_STATUS.PROCESSING,
        'statusTitle': 'In Progress',
        'statusSubtitle': "Your Order is Being Prepared for Shipment.",
        'date': null,
        'isActive': false,
        'isHidden': false,
    },
    {
        'step_id': 4,
        'id': 7,
        'defaultClass': '',
        'icon': 'fa-duotone fa-solid fa-arrow-turn-left text-white',
        'status': ORDER_STATUS.REFUNDED,
        'statusTitle': ORDER_STATUS.REFUNDED,
        'statusSubtitle': "Your Refund Has Been Processed!",
        'date': null,
        'isActive': false,
        'isHidden': true,
    },
    {
        'step_id': 4,
        'id': 8,
        'defaultClass': '',
        'icon': 'fa-sharp-duotone fa-solid fa-truck-fast text-white',
        'status': ORDER_STATUS.COMPLETED,
        'statusTitle': ORDER_STATUS.SHIPPED,
        'statusSubtitle': "Your Package is On Its Way!",
        'date': null,
        'isActive': false,
        'isHidden': false,
    },
    {
        'step_id': 4,
        'id': 9,
        'defaultClass': '',
        'icon': 'fa-duotone fa-solid fa-person-carry-box text-white',
        'status': ORDER_STATUS.READY_FOR_PICK_UP,
        'statusTitle': 'Ready',
        'statusSubtitle': "Your Order is Ready for Pickup at Your Convenience",
        'date': null,
        'isActive': false,
        'isHidden': true,
    },
    {
        'step_id': 5,
        'id': 10,
        'defaultClass': '',
        'icon': 'fa-sharp-duotone fa-solid fa-circle-check text-white',
        'status': ORDER_STATUS.DELIVERED,
        'statusTitle': ORDER_STATUS.DELIVERED,
        'statusSubtitle': "Thank You for Shopping With Us!",
        'date': null,
        'isActive': false,
        'isHidden': false,
    },
];

const MARKER_TYPE = {
    ALL: 'all',
    PARTNERS: 'partners',
    CUSTOMERS: 'customers',
};

export default {
    ECMURL: ECMURL,
    TIPMURL: TIPMURL,
    SITEURL: SITEURL,
    SERVICESURL: SERVICESURL,
    MAKROURL: MAKROURL,
    TIPM_SUPPORT_EMAIL: TIPM_SUPPORT_EMAIL,
    ECM_SUPPORT_EMAIL: ECM_SUPPORT_EMAIL,
    SUPPORT_EMAIL: SUPPORT_EMAIL,
    PARTNERURL: PARTNERURL,
    SITEAUTH: SITEAUTH,
    //TIPM_AUTH: TIPM_AUTH,
    //ECM_AUTH: ECM_AUTH,
    SHIPSTATION_AUTH: SHIPSTATION_AUTH,
    LOGIN_TYPE: LOGIN_TYPE,
    AUTH_KEY: AUTH_KEY,
    ORDER_STATUS: ORDER_STATUS,
    VEHICLE_CONFIG_META: VEHICLE_CONFIG_META,
    VIN_META: VIN_META,
    RVC_TITLE: RVC_TITLE,
    LID_TITLE: LID_TITLE,
    COLORED_LID_META: COLORED_LID_META,
    PROVIDE_VIN_LATER: PROVIDE_VIN_LATER,
    DATABASE_URL: DATABASE_URL,
    SHIPSTATION_BASE_URL: SHIPSTATION_BASE_URL,
    STAMPS_COM_BASE_URL: STAMPS_COM_BASE_URL,
    FEDEX_BASE_URL: FEDEX_BASE_URL,
    FEDEX_TRACKING_BASE_URL: FEDEX_TRACKING_BASE_URL,
    USPS_TRACKING_BASE_URL: USPS_TRACKING_BASE_URL,
    DHL_TRACKING_BASE_URL: DHL_TRACKING_BASE_URL,
    STAMPS_COM_LOGO: STAMPS_COM_LOGO,
    FEDEX_LOGO: FEDEX_LOGO,
    DHL_LOGO: DHL_LOGO,
    STAMPS_COM_CARRIER_CODE: STAMPS_COM_CARRIER_CODE,
    STAMPS_COM_SERVICE_CODE: STAMPS_COM_SERVICE_CODE,
    FEDEX_CARRIER_CODE: FEDEX_CARRIER_CODE,
    DHL_CARRIER_CODE: DHL_CARRIER_CODE,
    SHIPSTATION_STOREID_TIPM: SHIPSTATION_STOREID_TIPM,
    SHIPSTATION_STOREID_ECM: SHIPSTATION_STOREID_ECM,
    COMPANY_PHONE_NUMBER: COMPANY_PHONE_NUMBER,
    COMPANY_ADDRESS: COMPANY_ADDRESS,
    PARTNER_DISCOUNT_PERCENTAGE: PARTNER_DISCOUNT_PERCENTAGE,
    CURRENT_STOREID: CURRENT_STOREID,
    NOTE_TEXT: NOTE_TEXT,
    RVC_PRICE: RVC_PRICE,
    COLORED_LID_PRICE: COLORED_LID_PRICE,
    TIMELINE_OBJECT: TIMELINE_OBJECT,
    FEDEX_COLOR: FEDEX_COLOR,
    STAMPS_COM_COLOR: STAMPS_COM_COLOR,
    DHL_COLOR: DHL_COLOR,
    TIMEOUT_DURATION: TIMEOUT_DURATION,
    AUTH_INTERVAL: AUTH_INTERVAL,
    STATES: STATES,
    MARKER_TYPE: MARKER_TYPE,
    CSR_AGENTS_LOOKUP_TIPM: CSR_AGENTS_LOOKUP_TIPM
}